module.exports = __webpack_public_path__ + "static/img/ic_review.ba106c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_review.svg
// module id = 9w7v
// module chunks = 10